import { Component, inject } from '@angular/core';
import { BadgeModule } from 'primeng/badge';
import { DrawerModule } from 'primeng/drawer';

import { AuthService } from '../../../modules/auth/services/auth.service';
import { LayoutService } from '../../services/app.layout.service';
import packageJson from './../../../../../package.json';

@Component({
  selector: 'app-profilemenu',
  templateUrl: './profilesidebar.component.html',
  standalone: true,
  imports: [DrawerModule, BadgeModule],
  styleUrl: './profilesidebar.component.scss',
})
export class ProfileSidebarComponent {
  private layoutService = inject(LayoutService);
  private authService = inject(AuthService);

  username = '';

  version = packageJson.version;

  get visible(): boolean {
    return this.layoutService.state.profileSidebarVisible;
  }

  set visible(_val: boolean) {
    this.layoutService.state.profileSidebarVisible = _val;
  }

  logout() {
    this.authService.logout();
  }
}
